export const cropZones = {
  mug: { x: 250, y: 320, width: 300, height: 300 },
  tshirt: { x: 320, y: 220, width: 350, height: 350 },
  pins: { x: 141, y: 134, width: 470, height: 470 },
};
